import { useState } from "react";

export function useFormState() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState("SEGOV.MS");
  const [error, setError] = useState<string | undefined>(undefined);

  const handleChange = (event: any, field: string) => {
    const value = event.target.value;
    switch (field) {
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        break;
      case "domain":
        setSelectedDomain(value);
        break;
    }
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const clearError = () => setError(undefined);

  return {
    email,
    password,
    showPassword,
    selectedDomain,
    error,
    setError,
    handleChange,
    togglePasswordVisibility,
    clearError,
  };
}
